var React = require('react');

function Crutch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M281 49.91a16 16 0 0 1 0-22.63l22.69-22.6a16 16 0 0 1 22.62 0l181 181a16 16 0 0 1-.06 22.6l-22.62 22.63a16 16 0 0 1-22.63 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M382.91 197l-55.1 55.12-67.89-67.92L315 129.1l-45.23-45.25L160.1 193.52a96.05 96.05 0 0 0-25.67 46.29l-27.74 120.26-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.85 95.85 0 0 0 46.29-25.65l109.68-109.68zM273.24 306.66a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.23 32.23 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z","className":"fa-primary","key":2})]);
}

Crutch.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Crutch;

Crutch.default = Crutch;
